import React from 'react';
import type { PluginProps } from 'ricos-types';

import { HtmlViewer } from '../viewer/html-viewer';

export const Html: React.FC<PluginProps> = ({ settings, componentData }) => {
  return <HtmlViewer componentData={componentData} iframeSandboxDomain={''} settings={settings} />;
};
